import React from 'react'
import { Link } from 'react-router-dom'

export default function MentionsLegales() {
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={h1Style}>Mentions légales</h1>
        <p style={metaStyle}>Dernière mise à jour : 18 avril 2026</p>

        <section style={sectionStyle}>
          <h2 style={h2Style}>1. Éditeur du site</h2>
          <p style={pStyle}>
            Le site <strong>kudogenius.com</strong> est édité par la société <strong>Nutryn</strong>, EURL au capital variable,
            immatriculée au Registre du Commerce et des Sociétés sous le numéro SIRET 882 544 414 00015.
          </p>
          <p style={pStyle}>
            <strong>Siège social :</strong> 480 route des marais de Culas, 74330 Sillingy, France<br/>
            <strong>Gérante et directrice de la publication :</strong> Virginie Terrier<br/>
            <strong>Contact :</strong> contact@nutrygenius.com
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>2. Hébergement</h2>
          <p style={pStyle}>
            <strong>Hébergement du site web :</strong> Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis.
            Site : <a href="https://vercel.com" target="_blank" rel="noreferrer" style={linkStyle}>vercel.com</a>
          </p>
          <p style={pStyle}>
            <strong>Hébergement des données :</strong> Supabase Inc., 970 Toa Payoh North #07-04, Singapore 318992.
            Site : <a href="https://supabase.com" target="_blank" rel="noreferrer" style={linkStyle}>supabase.com</a>.
            Les données sont hébergées dans l'Union européenne (région AWS eu-west).
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>3. Propriété intellectuelle</h2>
          <p style={pStyle}>
            L'ensemble du contenu du site kudogenius.com (textes, graphismes, logos, icônes, images, logiciels)
            est la propriété exclusive de Nutryn EURL ou de ses partenaires et est protégé par les lois françaises
            et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation ou
            diffusion, en tout ou partie, du contenu de ce site est interdite sans autorisation écrite préalable.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>4. Protection des données personnelles</h2>
          <p style={pStyle}>
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique
            et Libertés, vous disposez de droits sur vos données personnelles. Pour en savoir plus, consultez
            notre <Link to="/politique-confidentialite" style={linkStyle}>Politique de confidentialité</Link>.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>5. Cookies</h2>
          <p style={pStyle}>
            À ce jour, le site kudogenius.com n'utilise aucun cookie publicitaire ni outil de suivi analytique.
            Seuls des cookies techniques strictement nécessaires au fonctionnement de l'application
            (authentification, session) sont utilisés. Cette politique sera mise à jour en cas d'évolution.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>6. Droit applicable</h2>
          <p style={pStyle}>
            Les présentes mentions légales sont régies par le droit français. En cas de litige,
            les tribunaux compétents seront ceux du ressort du siège social de l'éditeur.
          </p>
        </section>

        <div style={{ textAlign: 'center', marginTop: 32 }}>
          <Link to="/" style={linkStyle}>← Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  )
}

const containerStyle = {
  minHeight: '100vh', background: '#f8fafc', padding: '40px 20px',
  fontFamily: "'Inter', sans-serif", display: 'flex', justifyContent: 'center'
}
const cardStyle = {
  background: '#fff', borderRadius: 16, padding: '40px 36px',
  maxWidth: 720, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
  border: '1px solid #e2e8f0'
}
const h1Style = {
  fontFamily: "'Playfair Display', serif", fontSize: 28, fontWeight: 900,
  color: '#1e293b', marginBottom: 4
}
const metaStyle = { fontSize: 12, color: '#94a3b8', marginBottom: 32 }
const sectionStyle = { marginBottom: 28 }
const h2Style = { fontSize: 16, fontWeight: 700, color: '#1e293b', marginBottom: 8 }
const pStyle = { fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 8 }
const linkStyle = { color: '#2563eb', fontWeight: 600, textDecoration: 'underline' }
